import axios from "axios";

export const getActivepanels = async (id) => {
  try {
    const res = await axios.get(
      `/api/Company/getActiveTenantPanel?tenantId=${id}`
    );
    return res;
  } catch (error) {
    console.log(error.message);
  }
};

export const getRedemptionRequests = async (id) => {
  try {
    const res = await axios.get(
      `/api/company/getPanelistRedemptionHistory?panelId=${id}`
    );
    return res;
  } catch (error) {
    console.log(error.message);
  }
};

export const approveRequest = async (id, data, panelGuid) => {
  try {
    const res = await axios.patch(
      `/api/company/updateRedeemRequestStatus?redeemRequestId=${id}&panelGuid=${panelGuid}`,
      data
    );
    return res;
  } catch (error) {
    console.log("Couldn't perform the action", error.message);
    return error;
  }
};

export const getRedeemptionRequestsByFilter = async (panelId,data) => {
  try {
    const res = await axios.post(
      `/api/company/getRedemptionRequest?panelId=${panelId}`,
      data
    );
    return res;
  } catch (error) {
    console.log("err", error.message);
  }
};

export const getRedemptionData = async (redeemStatus, startDate, endDate) =>{
  try {
    const res = await axios.get(
      `/api/Company/getRedemptionData?redeemStatus=${redeemStatus}&startDate=${startDate}&endDate=${endDate}`
    );
    return res;
  } catch (error) {
    return error;
  }}

export const getPanelistCategory = async (data) => {
  try {
    const res = await axios.get(
      `/api/company/getPanelistCategory`
    );
    return res;
  } catch (error) {
  }
};
export const getPanelCountryLanguage = async (panelId) => {
  try {
    const res = await axios.get(
      `/api/Company/getPanelCountryLanguage/${panelId}`
    );
    return res;
  } catch (error) {
  }
};